import React from 'react';

/**
 * Switch estándar de la app. ON = bg-accent, OFF = bg-line (visible sobre
 * tarjeta blanca en claro; en oscuro line = slate-700). Knob blanco fijo:
 * contrasta sobre ambos tracks en ambos modos.
 */
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Texto accesible (sr-only). Si se omite, el consumidor debe tener label visible propio. */
  label?: string;
  size?: 'sm' | 'md';
  className?: string;
}

const SIZES = {
  md: { track: 'h-6 w-11', knob: 'h-5 w-5', on: 'translate-x-5' },
  sm: { track: 'h-5 w-9', knob: 'h-4 w-4', on: 'translate-x-4' },
} as const;

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  label,
  size = 'md',
  className = '',
}) => {
  const s = SIZES[size];
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex flex-shrink-0 ${s.track} cursor-pointer rounded-full
        border-2 border-transparent transition-colors duration-200 ease-in-out
        focus:outline-none focus-visible:ring-2 focus-visible:ring-accent
        focus-visible:ring-offset-2 focus-visible:ring-offset-surface
        disabled:opacity-50 disabled:cursor-not-allowed
        ${checked ? 'bg-accent' : 'bg-line'} ${className}`}
    >
      {label && <span className="sr-only">{label}</span>}
      <span
        className={`pointer-events-none inline-block ${s.knob} transform rounded-full
          bg-white shadow ring-0 transition duration-200 ease-in-out
          ${checked ? s.on : 'translate-x-0'}`}
      />
    </button>
  );
};

export default Toggle;
